import { FaLightbulb, FaThermometerHalf, FaLock, FaMusic, FaBolt } from 'react-icons/fa';

export const demoDevicesData = [
  {
    id: 'lighting',
    icon: FaLightbulb,
    titleKey: 'interactiveDemo.device1.title',
    descKey: 'interactiveDemo.device1.description',
    color: '#ffaa00',
  },
  {
    id: 'climate',
    icon: FaThermometerHalf,
    titleKey: 'interactiveDemo.device2.title',
    descKey: 'interactiveDemo.device2.description',
    color: '#ff6b6b',
  },
  {
    id: 'security',
    icon: FaLock,
    titleKey: 'interactiveDemo.device3.title',
    descKey: 'interactiveDemo.device3.description',
    color: '#00d4ff',
  },
  {
    id: 'entertainment',
    icon: FaMusic,
    titleKey: 'interactiveDemo.device4.title',
    descKey: 'interactiveDemo.device4.description',
    color: '#9b59b6',
  },
  {
    id: 'energy',
    icon: FaBolt,
    titleKey: 'interactiveDemo.device5.title',
    descKey: 'interactiveDemo.device5.description',
    color: '#00ffcc',
  },
];
